var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21989 3.09998H15.6599C16.3399 3.09998 17.1899 3.56998 17.5499 4.14998L21.7299 10.83C22.1299 11.48 22.0899 12.5 21.6299 13.11L16.4499 20.01C16.0799 20.5 15.2799 20.9 14.6699 20.9H4.21989C2.46989 20.9 1.40993 18.98 2.32993 17.49L5.09989 13.06C5.46989 12.47 5.46989 11.51 5.09989 10.92L2.32993 6.48998C1.40993 5.01998 2.47989 3.09998 4.21989 3.09998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiner);
export default __webpack_public_path__ + "static/media/liner.cec2e00d060a5ceea2b6a870874492e8.svg";
export { ForwardRef as ReactComponent };